const SIA_FACEBOOK = "https://www.facebook.com/sia.schweiz";
const SIA_LINKEDIN =
  "https://www.linkedin.com/company/sia-schweizerischer-ingenieur-und-architektenverein";
const SIA_TWITTER = "https://twitter.com/sia_schweiz";
const SIA_YOUTUBE="https://www.youtube.com/user/SIAschweiz"
const MULTI_LANGUAGE_SLOGAN = {
  de: "Schweizerischer Ingenieur- und Architektenverein",
  fr: "Société suisse des ingénieurs et des architectes",
  it: "Società svizzera degli ingegneri e degli architetti",
  en: "Swiss society of engineers and architects",
};
const SIA_PHONE_NUMBER = "+41 44 283 15 15";
const SIA_EMAIL = "contact@sia.ch";
const SIA_STREET = "Selnaustrasse 16";
const SIA_ZIP = 8001;

export default {
  SIA_EMAIL,
  SIA_FACEBOOK,
  SIA_LINKEDIN,
  SIA_TWITTER,
  SIA_YOUTUBE,
  MULTI_LANGUAGE_SLOGAN,
  SIA_PHONE_NUMBER,
  SIA_EMAIL,
  SIA_STREET,
  SIA_ZIP,
};
